import { render, staticRenderFns } from "./deposit-table.vue?vue&type=template&id=3061b8ba&scoped=true&"
import script from "./deposit-table.vue?vue&type=script&lang=js&"
export * from "./deposit-table.vue?vue&type=script&lang=js&"
import style0 from "./deposit-table.vue?vue&type=style&index=0&id=3061b8ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3061b8ba",
  null
  
)

export default component.exports